module.exports = __webpack_public_path__ + "img/logo_icon.c05f4336.png";